import { render, staticRenderFns } from "./NetworkBubble.vue?vue&type=template&id=24c8cde6&"
import script from "./NetworkBubble.vue?vue&type=script&lang=js&"
export * from "./NetworkBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports